import { createScope } from "@zag-js/dom-query"

export const dom = createScope({})
